import { RecipientDetailProvider } from './context'
import { ExportDropdown } from './export'
/**
 * RecipientDetail Compound Component
 *
 * Namespace export for all recipient detail page components.
 * Following Vercel composition patterns for flexible, maintainable code.
 *
 * Usage:
 * ```tsx
 * <RecipientDetail.Provider recipientId={id}>
 *   <DetailFilterProvider>
 *     <BetaDisclaimer />
 *     <RecipientDetail.Header />
 *     <RecipientDetail.Sections>
 *       <RecipientDetail.SpendingTrend />
 *       <RecipientDetail.AwardMix />
 *       <RecipientDetail.TopAgencies />
 *       ...
 *     </RecipientDetail.Sections>
 *     <RecipientDetail.RecentAwards />
 *   </DetailFilterProvider>
 * </RecipientDetail.Provider>
 * ```
 */
import { RecipientHeader } from './RecipientHeader'
import { RecipientInsights } from './RecipientInsights'
import { RecipientMinimap } from './RecipientMinimap'
import { RecipientQuickActions } from './RecipientQuickActions'
import { RecipientSections } from './RecipientSections'
import {
  AwardCashFlowSection,
  AwardMixSection,
  CompetitionSection,
  ContractSizesSection,
  GeographySection,
  IndustrySection,
  OfficersSection,
  RecentAwardsSection,
  SetAsideSection,
  SpendingTrendSection,
  TopAgenciesSection,
} from './sections'

export const RecipientDetail = {
  // Core structure
  Provider: RecipientDetailProvider,
  Header: RecipientHeader,
  QuickActions: RecipientQuickActions,
  Insights: RecipientInsights,
  Minimap: RecipientMinimap,
  Sections: RecipientSections,

  // Export
  Export: ExportDropdown,

  // Analytics sections
  AwardCashFlow: AwardCashFlowSection,
  SpendingTrend: SpendingTrendSection,
  AwardMix: AwardMixSection,
  TopAgencies: TopAgenciesSection,
  Industry: IndustrySection,
  Geography: GeographySection,
  SetAsides: SetAsideSection,
  Competition: CompetitionSection,
  ContractSizes: ContractSizesSection,
  Officers: OfficersSection,
  RecentAwards: RecentAwardsSection,
}
